// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5a824cb2","103":"0a0a4aa8","123":"2d0d4e10","453":"c898d831","630":"3b2ed63c","736":"7050352c","905":"c20c3583"}[chunkId] + ".chunk.js";
};